// extracted by mini-css-extract-plugin
module.exports = {"root":"c640vWQ","image":"Dooauo","brandImage":"hGMy92","title":"akR2lN","price":"S3FSzg","promo":"bCjyn4","vertical":"sKrUQM","separator":"wH3RUL","tag":"qsyHl0"};